import React from 'react'
import Layout from '../../common/Layout/Layout'
import AdviserDataDumpContainer from '../../features/AdviserDataDump/AdviserDataDumpContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/adviser-dataDump',
  async action ({ params }) {
    return {
      title: 'Adviser Data Dump',
      component: <Layout containerWell ><AdviserDataDumpContainer /></Layout>
    }
  }

}
